import { InjectionToken } from "@angular/core";

export interface Environment {
  addOrganisationFunction: string;
  allContentCollection: string;
  allContentDB: string;
  apiUrl: string;
  appID: string;
  currentProgressCollection: string;
  databaseName: string;
  enrolOrganisationAdminFunction: string;
  enrolSinglePatientFunction: string;
  enrolTherapistFunction: string;
  groupListCollection: string;
  groupProtocolLisCollection: string;
  groupProtocolListDB: string;
  groupsListDB: string;
  journalEntryCollection: string;
  lifePracticeCustomEntriesCollection: string;
  lifePracticeCustomCollection: string;
  lifePracticeCollection: string;
  lifePracticeResultCollection: string;
  lifePracticeResultDB: string;
  liveQuestCollection: string;
  liveQuestDB: string;
  organisationCollection: string;
  patientProfileCollection: string;
  mongoReadsInBody?: boolean;
  production?: boolean;
  profileCollection: string;
  profileDB: string;
  protocolCollection: string;
  protocolDB: string;
  questResultCollection: string;
  questResultDB: string;
  sessionCollection: string;
  sessionDB: string;
  userProfileCollection: string;
  userProfileDB: string;
  webinarDB: string;
  webinarListCollection: string;
  skillEntryCollection: string;
  patientConditionCollection?: string;
  getSmsNumberVerificationCodeFunction: string;
  confirmSmsNumberVerificationFunction: string;
  notesDB: string;
  notesCollection: string;
  smsMessageRequestDB: string;
  smsMessageRequestCollection: string;
  smsMessageAttemptDB: string;
  smsMessageAttemptCollection: string;
  passwordResetModeForTherapist?: string;
  passwordResetModeForOrgAdmin?: string;
  passwordResetModeForPatient?: string;
  createWebinarFunction?: string;
  resetWebinarFunction?: string;
  createWebinarTestForTherapistFunction?: string;
  updateWebinarFunction?: string;
  resendInvitationFunction?: string;
  sendPatientAddedToGroupEmail?: string;
  assignGroupToPatientsFunction?: string;
  assignIndividualCourseFunction?: string;
  removeIndividualCourseFunction?: string;
  notificationDB: string;
  notificationCollection: string;
  notificationItemCollection: string;
  createNotificationFunction?: string;
  updateNotificationFunction?: string;
  draftCoursePreview?: boolean;
  enableCourseCustomisation?: boolean;
}

export const ENVIRONMENT_TOKEN: InjectionToken<Environment> =
  new InjectionToken("ENVIRONMENT_TOKEN");
